// extracted by mini-css-extract-plugin
export default {"modal":"EditProductModal_modal__fVml2","modalContent":"EditProductModal_modalContent__qL6SE","active":"EditProductModal_active__GR4L7"};